export const canvasMargin = 36; /* Pixels */
export const canvasButtonHeight = 48; /* Pixels */
export const canvasButtonMargin = 24; /* Pixels */
